import { request } from '../client';

export const getAppConfig = () => request('/config', { auth: false });

export const getServiceablePincodes = () => request('/serviceable-pincodes');

// The serving outlet's delivery times. The backend resolves that outlet from
// the X-Delivery-* geography — the browsing location by default, or a pinned
// `deliveryGeography` (Checkout pins the delivery address). No outlet is sent.
export const getDeliverySlots = (options = {}) => request('/delivery-slots', options);

export const getPaymentSettings = () => request('/settings/payment');

export const getPolicies = () => request('/policies');
